// 邮寄材料分为以下四个阶段，描述文本对应的是不同阶段
export const expressDescSteps = {
  // 发起材料邮保司
  toCheck: '理算完成后，若需要邮寄材料到保司，并审核邮寄材料的扫描件均合格后，请发起“材料邮寄保司”任务到单证岗，审核通过后，才可提交已定损。',
  // 单证岗材料审核
  checkAgent: '单证岗进行审核，通过后可提交已定损。',
  // 材料已邮寄
  posted: '单证岗将材料寄出后，需要录入运单信息。'
}

// 邮寄材料任务状态; 邮寄初审-toCheck, 邮寄退回-returned, 补充邮寄-added,  待邮寄-toPost, 已邮寄-posted
export const expressStatusMap = [[''], ['toCheck', 'returned', 'added'], ['toPost', 'posted']]